import { taskKeys } from '../tasks/queryKeys';
import { broadcastKeys } from '../broadcasts/queryKeys';

export const commentKeys = {
  task: (id: string) => [...taskKeys.task(id), 'comments'] as const,
  broadcast: (id: string) =>
    [...broadcastKeys.broadcast(id), 'comments'] as const,
};
